// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bidding-price-data[data-v-3df75dac]{display:flex;flex-direction:column;gap:1rem}.bidding-price-data>*[data-v-3df75dac]{margin-bottom:0}.bidding-price-data__bid-value[data-v-3df75dac]{font-weight:700}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
